import Vue from 'vue'
import VueRouter from 'vue-router'
import globalData from '../lib/globalData';

Vue.use(VueRouter)

const routes = [
    { path: '/', redirect: {name: 'Conversations'} },
    { path: '/conversations', name: 'Conversations', component: () => import("../views/page/ConversationView.vue")},
    { path: '/connection', name: 'Connection', component: () => import("../views/page/ConnectionView.vue")},
    { path: '/connection/:channel', name: 'Connection', component: () => import("../views/page/ConnectionView.vue")},
    { path: '/setting', name: 'Setting', component: () => import("../views/page/SettingView.vue")},
    { path: '/automation', name: 'Automation', component: () => import("../views/page/AutomationView.vue")},
    { path: '/dashboard', name: 'Dashboard', component: () => import("../views/page/DashboardView.vue")},
    { path: '/iframe', name: 'IframeChatContent', component: () => import("../views/page/IframeChatContent")},
    { path: '/review', name: 'Review', component: () => import("../views/page/ReviewView")},
    { path: '/orders', name: 'Orders', component: () => import("../views/page/OrderView")},
    { path: '/account-management', name: 'AccountManagement', component: () => import("../views/page/AccountManagement")},
]

routes.forEach((r) => {
    if (r.path != "/") r.children = [].concat({ path: "/c/:companyCode" + r.path });
});

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {

    if (to.name === 'Setting' || to.name === 'Automation'|| to.name === 'Dashboard') {
        if (globalData.isAdmin) {
            next()
        } else {
            next('/conversations') // Thay đổi '/login' thành đường dẫn trang đăng nhập của bạn
        }
    } else {
        next()
    }
    if (to.name === 'AccountManagement') {
        if (globalData.logged_in_user.username.includes('sota/')) {
            next()
        } else {
            next('/conversations') // Thay đổi '/login' thành đường dẫn trang đăng nhập của bạn
        }
    }
})

export default router
